import Link from 'next/link';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './eventBanner.module.scss';

const cx = classnames.bind(styles);

const DchampsEventBanner = () => {
  return (
    <Link href={RouteUrl.EVENT_PHS_DCHAMPS} legacyBehavior>
      <a className={cx('dChampsEventBanner')} role="button">
        <span className={cx('hidden')}>
          9월 디챔스 이벤트 전격 오픈. 내 티어 확인하고 맥북과 스카우트 제의를 받아보세요.
        </span>
      </a>
    </Link>
  );
};

export default DchampsEventBanner;
